import apiClient from '../../../api/client';

const reportService = {
  
  // Get sales data with date range filtering
  getSalesGraphByDates: async (startDate, endDate, filterType = 'monthly') => {
    try {
      const params = { filter_type: filterType };
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      console.log("Sending report query with params:", params);
      
      const response = await apiClient.get('/api/v1/report/report-sales-graph', { params });
      console.log("Full sales graph response:", response);
      
      // Handle different response structures
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        // Try to extract any array from the response
        const possibleArrays = Object.values(response.data).filter(val => Array.isArray(val));
        if (possibleArrays.length > 0) {
          return possibleArrays[0];
        }
      }
      
      return [];
    } catch (error) {
      console.error('Error fetching sales graph data:', error);
      return [];
    }
  },

  // Get order summary with date range filtering
  getOrderSummaryByDates: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      console.log("Sending order summary query with params:", params);
      
      const response = await apiClient.get('/api/v1/report/report-order-summary', { params });
      console.log("Full order summary response:", response);
      
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
        // If it's a single object, wrap it in an array
        return [response.data];
      }
      
      return [];
    } catch (error) {
      console.error('Error fetching order summary:', error);
      return [];
    }
  },

  // Get top menu items with date range filtering
  getTopMenuItemByDates: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      console.log("Sending top menu items query with params:", params);
      
      const response = await apiClient.get('/api/v1/report/report-menu-item', { params });
      console.log("Full menu items response:", response);
      
      if (response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        const possibleArrays = Object.values(response.data).filter(val => Array.isArray(val));
        if (possibleArrays.length > 0) {
          return possibleArrays[0];
        }
      }
      
      return [];
    } catch (error) {
      console.error('Error fetching top menu items:', error);
      return [];
    }
  },

  // Get sales by category
  getSalesByCategory: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      console.log("Sending category sales query with params:", params);
      
      const response = await apiClient.get('/api/v1/report/sales-by-category', { params });
      console.log("Full category sales response:", response);
      
      let data = [];
      if (response.data && Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        data = response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        const possibleArrays = Object.values(response.data).filter(val => Array.isArray(val));
        if (possibleArrays.length > 0) {
          data = possibleArrays[0];
        }
      }
      
      // Handle duplicate names by appending index
      const nameMap = new Map();
      return data.map((item, index) => {
        if (nameMap.has(item.name)) {
          const count = nameMap.get(item.name) + 1;
          nameMap.set(item.name, count);
          return { ...item, name: `${item.name} (${count})`, id: `${item.name}-${index}` };
        } else {
          nameMap.set(item.name, 1);
          return { ...item, id: `${item.name}-${index}` };
        }
      });
    } catch (error) {
      console.error('Error fetching sales by category:', error);
      return [];
    }
  },

  // Get sales by payment method
  getSalesByPaymentMethod: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      console.log("Sending payment method query with params:", params);
      
      const response = await apiClient.get('/api/v1/report/sales-by-payment-method', { params });
      console.log("Full payment method sales response:", response);
      
      let data = [];
      if (response.data && Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        data = response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        const possibleArrays = Object.values(response.data).filter(val => Array.isArray(val));
        if (possibleArrays.length > 0) {
          data = possibleArrays[0];
        }
      }
      
      // Handle duplicate names
      const nameMap = new Map();
      return data.map((item, index) => {
        if (nameMap.has(item.name)) {
          const count = nameMap.get(item.name) + 1;
          nameMap.set(item.name, count);
          return { ...item, name: `${item.name} (${count})`, id: `${item.name}-${index}` };
        } else {
          nameMap.set(item.name, 1);
          return { ...item, id: `${item.name}-${index}` };
        }
      });
    } catch (error) {
      console.error('Error fetching sales by payment method:', error);
      return [];
    }
  },
  
  testConnection: async () => {
    try {
      const response = await apiClient.get('/api/v1/report/dashboard-order-summary');
      console.log("API Test response:", response);
      return response.data;
    } catch (error) {
      console.error('API test error:', error);
      throw error; // Rethrow to allow caller to handle
    }
  }
};

export default reportService;